import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate , Outlet } from 'react-router-dom';
import AgentDashboard from './AgentDashboard';
import AuthPage from './AuthPage';
import MyFilesDashboard from './MyFilesDashboard';
import AgentSettings from './AgentSettings';
 
 
const   ProtectedRoute = () => {
  // בדיקה אם קיים טוקן (כאן בדוגמה מ-localStorage) 
  const token = localStorage.getItem('token');  

  // אם אין טוקן, נחזיר את המשתמש לעמוד ההתחברות
  if (!token) {
    return <Navigate to="/auth" replace />;
  }

  // אם יש טוקן, ה-Outlet ירנדר את רכיב הבן שהגדרנו בתוך הנתיב
  return <Outlet />;
}


const   AuthRedirect = () => {
  // בדיקה אם קיים טוקן (כאן בדוגמה מ-localStorage) 
  const token = localStorage.getItem('token'); 

  // אם אין טוקן, נחזיר את המשתמש לעמוד ההתחברות
  if (token) {
    return <Navigate to="/agent" replace />;
  }

  // אם יש טוקן, ה-Outlet ירנדר את רכיב הבן שהגדרנו בתוך הנתיב
  return <Outlet />;
}

export default function App() {
  return (
    <Router>
      <Routes>
        {/* עמוד ברירת המחדל מפנה ישירות ל-MyFilesDashboard כפי שהיה ב-useState */}
        <Route path="/" element={<Navigate to="/agent" replace />} />
        
        

        <Route element={<AuthRedirect />}>

        {/* נתיבי העמודים השונים באפליקציה */}
            <Route path="/auth" element={<AuthPage />} />
         </Route>
        {/* <Route path="/files" element={<MyFilesDashboard />} /> */}
        {/* <Route path="/agent" element={<AgentDashboard />} /> */}
        {/* <Route path="/settings" element={<AgentSettings />} /> */}
        

        <Route element={<ProtectedRoute />}>
          <Route path="/files" element={<MyFilesDashboard />} />
          <Route path="/agent" element={<AgentDashboard />} />
          <Route path="/settings" element={<AgentSettings />} />
        </Route>
        
        {/* נתיב גיבוי למקרה שהמשתמש הגיע לכתובת לא קיימת */}
        <Route path="*" element={<Navigate to="/agent" replace />} />
      </Routes>
    </Router> 
  );
}
